var api = "https://api.qingcigame.com";
var initialSlide = 0;

const DEFAULT_LANGUAGE = "zh_HK";
let language_index = DEFAULT_LANGUAGE; //标识语言

var obj = {
    index: function() {
        this.preloading(); // 预加载
        this.indexBind(); // 首页按钮
        this.countNum(); //阿里云埋点
        this.language(); // 多语言
        this.share(); //分享
    },
    // 图片资源预加载
    preloading: function() {
        var queue = new createjs.LoadQueue();
        let preload_flag = layer.load(2, { shade: [0.1, '#fff'] });
        queue.on("progress", function(e) {
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
        }, this);
        queue.on("error", function(e) {
            console.log('loading images fail', e)
        })
        queue.on("complete", function(e) {

            layer.close(preload_flag);
            // console.log('loading images complete', e)
            //加载完成执行操作
            var _this = this;
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(1000);
            $('.index').addClass('index-show');
            setTimeout(function() {
                $('.preloading').remove();
            }, 1000)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '/pre-order/images/pc/zh-tw/index_bg-fb4e894e22.png',
            '/pre-order/images/pc/language_btn-77ac4d41c5.png',
            '/pre-order/images/icon_img-27cba2de40.png',
            '/pre-order/images/qc_logo-0b52723a87.png',
            '//download4.qcplay.com/qcgame-api/YQ9CT0glS2Xb4AxThdXJhbnW3o5qcoFaXeIrN2M4.png',
            '//download4.qcplay.com/qcgame-api/PWHlJth5J0rNHh1kQlpgSsF2c9PPOROUNT12jghk.png',
            '//download4.qcplay.com/pic/pre-order-multilingual/pc/en/main_title.png',
        ]);
    },
    // 首页暂未开放的几个按钮
    indexBind: function() {
        $('.monitor-btn').on('click', function() {
            var mon_btn = $(this).attr('data-event');
            obj.countNum(mon_btn);
        });

        // 点击背景关闭弹窗
        $('.popup_wrap').click(function(event) {
            if ($(event.target)[0] == $(this)[0]) {
                $('.popup').fadeOut().find('video').attr('src', '');
                Media.pause();
                $('.popup_wrap').fadeOut();
            }
        });

    },
    // 全屏滚动判断
    scroll: function() {
        $(window).scroll(function() {
            var scrollTop = $(this).scrollTop();
            var scrollHeight = $(document).height();
            var windowHeight = $(this).height();
            $(document).scrollTop() > 400 ? $('.return-top').fadeIn() : $('.return-top').fadeOut();
        });

        $('.return-top').click(function(event) {
            $(document).scrollTop(0);
        });
    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    },
    // 多语言
    language: function() {
        // console.log(navigator.language, navigator.userLanguage, language_index);
        let defaultLanguage = navigator.language || navigator.userLanguage;
        const that = this;
        jQuery(document).ready(function() {
            const language_cookie = $.cookie("language");
            // console.log(language_cookie, "language_cookie");
            if (!language_cookie) {
                if (
                    defaultLanguage == "zh" ||
                    defaultLanguage == "zh-CN" ||
                    defaultLanguage == "zh-HK" ||
                    defaultLanguage == "zh-TW" ||
                    defaultLanguage == "en-US" ||
                    defaultLanguage == "en"
                ) {
                    if (defaultLanguage == "zh") {
                        language_index = "zh";
                    } else if (defaultLanguage == "zh-CN") {
                        language_index = "zh_CN";
                    } else if (defaultLanguage == "en") {
                        language_index = "en";
                    } else if (defaultLanguage == "en-US") {
                        language_index = "en_US";
                    } else {
                        language_index = "zh_HK";
                    }
                }

                $.cookie("language", language_index);
            } else {
                language_index = language_cookie;
            }

            if (language_index == "zh" || language_index == "zh_CN") {
                $(".zh").addClass("on");
            } else if (language_index == "en" || language_index == "en_US") {
                $(".en").addClass("on");
            } else {
                $(".zh_HK").addClass("on");
            }
            that.loadProperties(language_index);
        });
        // 切换语言
        $(".language-change-box .change-btn").on("click", function() {
            let languageType = $(this).data("id");
            if ($(this).hasClass("on")) {
                return;
            }
            $(".language-change-box .change-btn").removeClass("on");
            // console.log(languageType, "languageType");
            language_index = languageType || DEFAULT_LANGUAGE;
            that.loadProperties(language_index);
            $.cookie("language", language_index);
            $(this).addClass("on");

            $(".footer-content").removeClass("on");
            $(`.${language_index}`).addClass("on");
        });
    },
    // 调用多语言
    loadProperties: function(type) {
        const that = this;
        jQuery.i18n.properties({
            name: "strings", // 资源文件名称
            path: "/pre-order/language/", // 资源文件所在目录路径
            mode: "map", // 模式：变量或 Map
            language: type, // 对应的语言
            cache: false,
            encoding: "UTF-8",
            callback: function() {
                // 回调方法
                that.translateContent01();
                that.translateInfo();
            },
        });
    },
    // 修改网站信息
    translateInfo: function() {
        $(".page_title").html($.i18n.prop("title"));
        $(".page_keywords").html($.i18n.prop("keywords"));
        $(".page_description").html($.i18n.prop("description"));
    },
    // 修改第一屏图片
    translateContent01: function() {
        this.replaceBgimg(".content-01 .main", $.i18n.prop("index-bg-pc"));
        this.replaceBgimg("logo", $.i18n.prop("logo-img"));
        this.replaceBgimg("qrcode", $.i18n.prop("code-img"));
        this.replaceBgimg("main-title", $.i18n.prop("main-title-pc"));
    },
    // 切换语言替换图片
    replaceBgimg: function(className, url) {
        $(`.${className}`).css({
            background: `url(${url}) no-repeat`,
        });
    },
    // 分享
    share: function() {
        var share_icon =
            "//download4.qcplay.com/qcgame-api/2p32lTClJpq67FfpY1WKFjBHWzs9THvOs7QsovWM.png";
        var share_big_title = "時光旅行社- 入社邀請函";
        var share_min_title = "時光旅行即將開業、最強蝸牛跨時空助戰！";
        var share_link = window.location.href;
        outside.share(share_icon, share_big_title, share_min_title, share_link);
    }
}